export const categories = [
  { id: 1, name: '热门推荐', slug: 'hot', icon: 'ri-fire-line', description: '精选热门影视，大家都在看' },
  { id: 2, name: '动作片', slug: 'action', icon: 'ri-sword-line', description: '热血刺激的动作大片' },
  { id: 3, name: '喜剧片', slug: 'comedy', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的喜剧佳作' },
  { id: 4, name: '爱情片', slug: 'romance', icon: 'ri-heart-line', description: '浪漫动人的爱情故事' },
  { id: 5, name: '科幻片', slug: 'scifi', icon: 'ri-rocket-line', description: '脑洞大开的科幻巨制' },
  { id: 6, name: '恐怖片', slug: 'horror', icon: 'ri-ghost-line', description: '惊险刺激的恐怖体验' },
  { id: 7, name: '动画片', slug: 'animation', icon: 'ri-movie-line', description: '精彩纷呈的动画世界' },
  { id: 8, name: '电视剧', slug: 'tv', icon: 'ri-tv-line', description: '热门剧集一网打尽' },
  { id: 9, name: '综艺', slug: 'variety', icon: 'ri-music-line', description: '欢乐爆笑的综艺节目' },
  { id: 10, name: '纪录片', slug: 'documentary', icon: 'ri-global-line', description: '真实震撼的纪录佳作' },
];

export const movies = [
  {
    id: 1,
    title: '星际穿越',
    year: 2014,
    rating: 9.4,
    category: 'scifi',
    categoryName: '科幻片',
    duration: '169分钟',
    director: '克里斯托弗·诺兰',
    actors: ['马修·麦康纳', '安妮·海瑟薇', '杰西卡·查斯坦'],
    description: '在不远的未来，地球气候恶化，水资源枯竭，饥荒肆虐。前NASA宇航员库珀在女儿墨菲的书房里发现了奇怪的重力现象，由此被卷入了一场拯救人类的宏大星际旅程。他穿越虫洞，前往遥远的星系寻找人类的新家园。面对时间的残酷流逝与亲情的不舍羁绊，库珀必须做出人生中最重要的选择。',
    imageSeq: 'movie-interstellar',
    featured: true,
  },
  {
    id: 2,
    title: '流浪地球2',
    year: 2023,
    rating: 8.3,
    category: 'scifi',
    categoryName: '科幻片',
    duration: '173分钟',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启了长达2500年的"流浪地球"计划。在这场关乎人类文明存续的宏大征程中，无数人挺身而出，用智慧与勇气守护家园。年轻人的抉择、老科学家的牺牲，共同谱写了人类最壮丽的史诗篇章。',
    imageSeq: 'movie-wandering-earth',
    featured: true,
  },
  {
    id: 3,
    title: '你好，李焕英',
    year: 2021,
    rating: 7.8,
    category: 'comedy',
    categoryName: '喜剧片',
    duration: '128分钟',
    director: '贾玲',
    actors: ['贾玲', '张小斐', '沈腾'],
    description: '2001年，刚考上大学的贾晓玲意外穿越回1981年，与年轻时的母亲李焕英相遇。她决心要让母亲过上更好的生活，帮助母亲赢得排球比赛、追求更好的姻缘。然而在这段奇妙的旅程中，她逐渐发现母亲对她的爱远超她的想象，一段笑中带泪的母女故事就此展开。',
    imageSeq: 'movie-hi-mom',
    featured: true,
  },
  {
    id: 4,
    title: '长津湖',
    year: 2021,
    rating: 7.4,
    category: 'action',
    categoryName: '动作片',
    duration: '176分钟',
    director: '陈凯歌 / 徐克 / 林超贤',
    actors: ['吴京', '易烊千玺', '段奕宏'],
    description: '1950年，抗美援朝战争第二次战役中，中国人民志愿军第9兵团在极度严寒的恶劣环境下，与装备精良的美军王牌部队在长津湖地区展开了殊死搏斗。志愿军战士们以钢铁般的意志和无畏的牺牲精神，创造了抗美援朝战争中全歼美军一个整团的辉煌战绩。',
    imageSeq: 'movie-changjin',
    featured: true,
  },
  {
    id: 5,
    title: '哪吒之魔童降世',
    year: 2019,
    rating: 8.4,
    category: 'animation',
    categoryName: '动画片',
    duration: '110分钟',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '陈浩'],
    description: '天地灵气孕育出一颗混元珠，元始天尊将其分为灵珠和魔丸。灵珠投胎为人，助周伐纣；魔丸则会诞出魔王，为祸人间。然而阴差阳错，灵珠和魔丸被掉包。本应是灵珠英雄的哪吒却成了混世大魔王，面对众人的误解和天雷的宿命，哪吒喊出了"我命由我不由天"的呐喊。',
    imageSeq: 'movie-nezha',
  },
  {
    id: 6,
    title: '封神第一部',
    year: 2023,
    rating: 7.8,
    category: 'action',
    categoryName: '动作片',
    duration: '148分钟',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤'],
    description: '商王殷寿残暴无道，天下大乱。姬发觉醒，联合八百诸侯，踏上封神之路。昆仑仙人姜子牙携封神榜下山，寻找天下共主。一场关乎天命与人心的封神大战即将拉开序幕，各方势力明争暗斗，仙魔混战，神话史诗的壮丽画卷徐徐展开。',
    imageSeq: 'movie-fengshen',
  },
  {
    id: 7,
    title: '消失的她',
    year: 2022,
    rating: 7.5,
    category: 'horror',
    categoryName: '恐怖片',
    duration: '121分钟',
    director: '崔睿 / 刘翔',
    actors: ['朱一龙', '倪妮', '文咏珊'],
    description: '何非的妻子李木子在海外度假时神秘失踪。当他四处寻找无果时，一个陌生女人突然出现，声称自己就是他的妻子。面对这个冒充者，何非陷入了身份认同的漩涡之中。金牌律师陈麦介入调查，随着真相一步步浮出水面，一个令人震惊的秘密逐渐显露。',
    imageSeq: 'movie-lost-her',
  },
  {
    id: 8,
    title: '甄嬛传',
    year: 2011,
    rating: 9.3,
    category: 'tv',
    categoryName: '电视剧',
    duration: '76集',
    director: '郑晓龙',
    actors: ['孙俪', '陈建斌', '蔡少芬'],
    description: '雍正年间，少女甄嬛入选宫中，从一个不谙世事的单纯少女，在尔虞我诈的后宫争斗中步步为营，成长为善于权谋的深宫贵妃。她经历了姐妹反目、爱人背叛、生死沉浮，最终登上了权力的巅峰，却也失去了最初的纯真。这是一部展现清朝后宫残酷生存法则的经典古装剧。',
    imageSeq: 'tv-zhenhuan',
    featured: true,
  },
  {
    id: 9,
    title: '狂飙',
    year: 2023,
    rating: 8.5,
    category: 'tv',
    categoryName: '电视剧',
    duration: '39集',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    description: '以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开了长达二十年的生死较量。从一个小鱼贩到称霸一方的黑恶势力头目，高启强的发家史折射出社会变迁中的阴暗面。而安欣始终坚守初心，用二十年的坚持和牺牲，最终将黑恶势力绳之以法。',
    imageSeq: 'tv-kuangbiao',
  },
  {
    id: 10,
    title: '霸王别姬',
    year: 1993,
    rating: 9.6,
    category: 'romance',
    categoryName: '爱情片',
    duration: '171分钟',
    director: '陈凯歌',
    actors: ['张国荣', '张丰毅', '巩俐'],
    description: '段小楼与程蝶衣从小在戏班学艺，二人合演的《霸王别姬》名震京城。程蝶衣人戏不分，将对段小楼的兄弟之情错付为男女之爱。然而段小楼娶了菊仙，三人在动荡的时代洪流中，经历了半个世纪的爱恨纠葛与命运沉浮，最终以一场悲剧收场。华语电影的巅峰之作。',
    imageSeq: 'movie-farewell',
  },
  {
    id: 11,
    title: '速度与激情10',
    year: 2023,
    rating: 6.2,
    category: 'action',
    categoryName: '动作片',
    duration: '141分钟',
    director: '路易斯·莱特里尔',
    actors: ['范·迪塞尔', '杰森·莫玛', '米歇尔·罗德里格兹'],
    description: '多米尼克与他的家人面临有史以来最危险的对手——但丁。这个来自过去的复仇者，誓要摧毁多米尼克所珍视的一切。从罗马到巴西，从伦敦到南极，一场跨越全球的极速追逐战就此展开。面对前所未有的威胁，家人是唯一可以依靠的力量。',
    imageSeq: 'movie-fast10',
  },
  {
    id: 12,
    title: '铃芽之旅',
    year: 2022,
    rating: 7.2,
    category: 'animation',
    categoryName: '动画片',
    duration: '122分钟',
    director: '新海诚',
    actors: ['原菜乃华', '松村北斗', '深津绘里'],
    description: '17岁少女铃芽在九州的一个宁静小镇上，遇到了一位寻找"门"的青年草太。她追随着青年来到山中废墟，发现了一扇古老的门。门一旦被打开，灾难就会从门的另一边降临。铃芽与草太踏上了一场关乎日本存亡的关门之旅，在旅途中逐渐解开自己童年失去母亲的伤痛记忆。',
    imageSeq: 'movie-suzume',
  },
  {
    id: 13,
    title: '满江红',
    year: 2023,
    rating: 7.0,
    category: 'comedy',
    categoryName: '喜剧片',
    duration: '159分钟',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译'],
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信不翼而飞。小兵张大与亲兵营副统领孙均被卷入这场惊天阴谋之中，在限定的一个时辰内，他们必须找到凶手和密信。层层反转，步步惊心，最终揭示了一段令人热血沸腾的真相。',
    imageSeq: 'movie-manjianghong',
  },
  {
    id: 14,
    title: '三体',
    year: 2023,
    rating: 8.1,
    category: 'tv',
    categoryName: '电视剧',
    duration: '30集',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾'],
    description: '纳米科学家汪淼被警官史强带入一个神秘组织"科学边界"，由此揭开了地球基础科学遭遇异常干扰的真相。随着调查深入，一款神秘的三体游戏揭示了外星文明的存在。面对即将到来的末日危机，人类命运共同体就此展开了一场跨越四百年的宏大博弈。',
    imageSeq: 'tv-threebody',
  },
  {
    id: 15,
    title: '奥本海默',
    year: 2023,
    rating: 8.8,
    category: 'documentary',
    categoryName: '纪录片',
    duration: '180分钟',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙'],
    description: '二战期间，物理学家罗伯特·奥本海默被任命为"曼哈顿计划"的负责人，带领顶尖科学家团队在新墨西哥州的洛斯阿拉莫斯秘密研发原子弹。随着三位一体试验的成功，奥本海默成为了"原子弹之父"。然而核武器的威力让他陷入了深深的道德困境，他开始反对氢弹的研发，最终遭受了政治迫害。',
    imageSeq: 'movie-oppenheimer',
  },
  {
    id: 16,
    title: '鬼灭之刃 无限列车篇',
    year: 2020,
    rating: 8.3,
    category: 'animation',
    categoryName: '动画片',
    duration: '117分钟',
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮'],
    description: '炭治郎等人接到新任务，前往调查无限列车上的失踪事件。他们与炎柱炼狱杏寿郎汇合，共同登上列车。然而这趟列车已被魇梦控制，乘客们陷入梦境之中。在清醒与梦境的边缘，炭治郎必须找到击败鬼的方法。而更强大的上弦之三猗窝座的出现，让这场战斗变得更加惨烈。',
    imageSeq: 'movie-demonslayer',
  },
];

export const featuredMovies = movies.filter((m) => m.featured);

export const latestMovies = [
  { ...movies[1], updateTime: '2小时前更新' },
  { ...movies[8], updateTime: '4小时前更新' },
  { ...movies[6], updateTime: '6小时前更新' },
  { ...movies[13], updateTime: '8小时前更新' },
  { ...movies[2], updateTime: '10小时前更新' },
  { ...movies[14], updateTime: '12小时前更新' },
  { ...movies[4], updateTime: '1天前更新' },
  { ...movies[11], updateTime: '1天前更新' },
  { ...movies[9], updateTime: '2天前更新' },
  { ...movies[5], updateTime: '2天前更新' },
  { ...movies[3], updateTime: '3天前更新' },
  { ...movies[7], updateTime: '3天前更新' },
];

export const articles = [
  {
    id: 1,
    title: '为什么《星际穿越》是近十年最伟大的科幻电影？',
    summary: '诺兰用虫洞和黑洞编织了一场跨越时空的亲情史诗，科学与情感在浩瀚宇宙中完美交融。',
    content: '《星际穿越》不仅是一部科幻电影，更是一部关于爱与时间的哲学寓言。诺兰在影片中引入了真实的黑洞理论，让物理学家基普·索恩担任科学顾问，呈现了影史最接近科学真相的黑洞视觉——"卡冈图雅"。影片的核心并非星际旅行本身，而是库珀与女儿墨菲之间的情感纽带。当库珀在米勒星球上度过短短几小时，地球上却已过去了二十三年，这种时间流逝的不对等带来的情感冲击力，比任何视觉奇观都更加震撼。影片最后的五维空间段落，将科学与情感完美结合——"爱是唯一可以穿越时空的力量"，这正是诺兰想要传达的终极主题。',
    author: '夜猫影评人',
    date: '2024-07-15',
    movieId: 1,
    imageSeq: 'article-interstellar',
  },
  {
    id: 2,
    title: '《狂飙》为什么能成为现象级爆款？深度解析',
    summary: '一部扫黑除恶剧，凭什么让全民追剧上瘾？从角色塑造到社会隐喻，《狂飙》的成功绝非偶然。',
    content: '《狂飙》的成功在于它超越了一般扫黑剧的套路。剧中高启强的角色塑造堪称教科书级别——从市场里卑微的鱼贩，到京海市呼风唤雨的黑恶势力头目，张颂文用精湛的演技勾勒出了一个复杂立体的反派形象。观众对他既恨又同情的情感交织，正是《狂飙》最大的魅力所在。另一方面，安欣二十年的坚守代表了正义的力量，他的孤独与执着形成了与高启强崛起之路的双线叙事。剧中对时代变迁的刻画、社会治安问题的反思，以及人性善恶的探讨，使其不仅是一部娱乐作品，更是一面折射当代中国社会诸多面相的镜子。',
    author: '深夜剧评人',
    date: '2024-06-28',
    movieId: 9,
    imageSeq: 'article-kuangbiao',
  },
  {
    id: 3,
    title: '国漫崛起：《哪吒之魔童降世》开启了怎样的动画新时代？',
    summary: '50亿票房背后的秘密——国漫如何从模仿走向自信，从技术突破到文化表达。',
    content: '2019年夏天，《哪吒之魔童降世》以50亿票房创造了中国动画电影的历史。它的意义不仅在于商业成功，更在于向世界证明了中国动画人的创造力和工业实力。影片在传统神话的基础上进行了大胆改编，"我命由我不由天"的台词击中了当代年轻人的精神困境。制作层面，1800多个特效镜头、1318个特效元素、5000多个镜头，展现了中国动画工业的日趋成熟。更重要的是，它为中国神话宇宙的构建奠定了基础，后续的《姜子牙》《新神榜：哪吒重生》等作品，共同描绘了一幅国漫崛起的新图景。从技术追赶到文化自信，国漫正在书写属于自己的传奇。',
    author: '动画观察者',
    date: '2024-06-10',
    movieId: 5,
    imageSeq: 'article-nezha',
  },
  {
    id: 4,
    title: '《甄嬛传》播出13年，为什么还能让人百看不厌？',
    summary: '一部宫斗剧的生命力为何如此持久？从台词到表演，《甄嬛传》的经典密码全解析。',
    content: '《甄嬛传》播出已超过13年，却依然活跃在各大平台的二创圈层中，被网友称为"电子榨菜"。其经久不衰的秘诀在于：第一，剧作的严谨性——郑晓龙导演团队对清朝宫廷文化的考究还原，从服饰、礼仪到称谓都十分考究；第二，角色的丰满度——76集的篇幅让每个角色都有完整的成长弧线，即便配角也立体饱满；第三，台词的文学性——引经据典却又不失自然，"贱人就是矫情"等台词成为经典；第四，表演的精湛——孙俪、陈建斌、蔡少芬等人的演技至今仍被奉为教科书。一部好的作品能穿越时间的考验，《甄嬛传》正是这样的经典。',
    author: '古装剧爱好者',
    date: '2024-05-20',
    movieId: 8,
    imageSeq: 'article-zhenhuan',
  },
  {
    id: 5,
    title: '2024年最值得期待的国产电影大盘点',
    summary: '从科幻巨制到文艺佳作，今年下半年这些国产电影不容错过。',
    content: '2024年下半年，国产电影市场将迎来一波高质量作品的井喷。首先是《封神第二部》，延续第一部的史诗气质，将有更多神仙大战的宏大场面；科幻题材方面，《流浪地球3》的前期筹备消息让影迷热血沸腾，预计将探索更广阔的宇宙空间；动画电影领域，追光动画的《白蛇：浮生》延续前作的水墨美学，讲述白蛇传说的新篇章；现实主义题材中，多部关注社会议题的文艺片已在各大电影节斩获好评。整体来看，中国电影正在多元化发展，类型越来越丰富，制作水准持续提升，观众的期待值也越来越高。',
    author: '电影前瞻观察',
    date: '2024-05-05',
    movieId: null,
    imageSeq: 'article-2024movies',
  },
];

export const reputationList = [
  { id: 1, name: '追剧达人小王', rating: 5, comment: '用了夜猫电影院三年了，画质一直很稳定，更新速度也快。强烈推荐给喜欢追剧的朋友！', date: '2024-07-20' },
  { id: 2, name: '电影爱好者阿明', rating: 5, comment: '片源非常丰富，最新的电影基本都能找到。高清画质秒播不卡，观影体验特别好。', date: '2024-07-18' },
  { id: 3, name: '剧荒拯救者', rating: 4, comment: '分类很清晰，找片特别方便。唯一希望的是能增加更多美剧资源，总体非常满意。', date: '2024-07-15' },
  { id: 4, name: '深夜追剧人', rating: 5, comment: '作为一个经常熬夜追剧的人，夜猫电影院简直就是我的精神食堂。不卡顿、秒播、高清，全齐了！', date: '2024-07-12' },
  { id: 5, name: '老影迷张叔', rating: 5, comment: '从老电影到新片，资源相当丰富。经典老片的画质也修复得很好，难得的好平台。', date: '2024-07-10' },
  { id: 6, name: '学生党小李', rating: 4, comment: '免费高清看电影真的太香了！和室友一起在宿舍用投影看，效果完全不输影院。', date: '2024-07-08' },
  { id: 7, name: '家庭观影达人', rating: 5, comment: '周末经常带孩子一起看动画片，画质清晰，孩子看得开心。全家人一起看真的很温馨。', date: '2024-07-05' },
  { id: 8, name: '美剧控小陈', rating: 4, comment: '国产剧更新很快，美剧资源稍微少一些但质量很高。整体体验优秀，会一直用下去。', date: '2024-07-01' },
];